// extracted by mini-css-extract-plugin
export default {"break-holding-page":"BreakHoldingPage_break-holding-page__1Y02f","break-holding-page__text":"BreakHoldingPage_break-holding-page__text__3sNd9"};